module.exports = __webpack_public_path__ + "static/media/superset.3558e363.svg";